import { Layers } from "appworks/graphics/layers/layers";
import { SpineService } from "appworks/graphics/spine/spine-service";
import { Services } from "appworks/services/services";
import { Point } from "appworks/utils/geom/point";
import { RandomRangeInt } from "appworks/utils/math/random";
import { Timer } from "appworks/utils/timer";
import { gameLayers } from "game-layers";
import { Body } from "matter-js";
import { FowlAbstractObstacleSubcomponent } from "./fowl-abstract-obstacle-subcomponent";
import { SoundService } from "appworks/services/sound/sound-service";
import { Contract } from "appworks/utils/contracts/contract";

export class FowlDuckSubcomponent extends FowlAbstractObstacleSubcomponent {
    protected interval: number;
    protected xSpeed = RandomRangeInt(3, 10);

    constructor(
        public position: Point,
        public layer: Layers = gameLayers.FlingBonus
    ) {
        super(position, layer);

        this.spine = Services.get(SpineService).createSpineContainer("faf_duck", this.layer.getPosition("duck"));
        this.spine.setSpineAnchor({ x: 0.5, y: 0.5 });
        this.spine.play("idle");
        this.layer.add(this.spine);

        this.spine.landscape.setPosition(position);
        this.spine.portrait.setPosition(position);

        // update loop
        this.interval = Timer.setInterval(() => {
            this.position.x -= this.xSpeed;
            this.spine.landscape.setPosition(position);
            this.spine.portrait.setPosition(position);
        }, 0);
    }

    public checkCollision(foxPosition: Point): boolean {
        if (!this.spine) { return false; }

        if ((this.spine.landscape.x - foxPosition.x) < -this.layer.bounds.landscape.width) {
            this.destroy();
            return false;
        }

        return super.checkCollision(foxPosition);
    }

    public onCollision(foxBody: Body): void {
        super.onCollision(foxBody);
        this.animate().execute();
    }

    public animate(): Contract<void> {
        Services.get(SoundService).customEvent("faf_hit_duck");
        return super.animate();
    }

    public destroy(): void {
        Timer.clearInterval(this.interval);
        super.destroy();
    }
}